import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewWC2APP = () => import('./Index.vue')
const ViewBajarNovedadesApp = () => import('./Bajar_Novedades_App/Index.vue')


const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'wc_2_app',
        name: 'WC_2_APP',
        component: ViewWC2APP,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'bajar_novedades_app',
        name: 'Bajar Novedades App',
        component: ViewBajarNovedadesApp,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
